import {
  getAuthCooldownRemainingMs,
  getToken,
} from 'serviceWorker/services/config';

/** Set when this SW script is evaluated – a small uptime means the SW was just (re)started. */
const swStartedAt = Date.now();

export interface PullDiagnostics {
  swUptimeMs: number;
  hasTokenInMemory: boolean;
  authCooldownRemainingMs: number;
  /** `null` when the API is not available. */
  online: boolean | null;
}

/**
 * State attached to pull-failure logs, to tell apart a SW restart
 * (token lost from memory), an auth cooldown and a lost network.
 */
export function getPullDiagnostics(): PullDiagnostics {
  return {
    swUptimeMs: Date.now() - swStartedAt,
    hasTokenInMemory: Boolean(getToken()),
    authCooldownRemainingMs: getAuthCooldownRemainingMs(),
    online: readOnline(),
  };
}

function readOnline(): boolean | null {
  return typeof navigator !== 'undefined' ? navigator.onLine : null;
}

/** The worker knows it has no network: a download that does not run is expected, not an error. */
export function isWorkerOffline(): boolean {
  return readOnline() === false;
}
